module.exports = __webpack_public_path__ + "img/arrow-top-bottom-used.e980f459.svg";